import { SRMInfoSchema } from './SRMInfo.styles';

export const srmInfoStyles: SRMInfoSchema = {
  runnerDetails: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'epsilon.700',
  },
  placeNumber: {
    fontWeight: 'semibold',
    fontSize: 'xs',
    color: 'epsilon.700',
  },
  srmContainer: {
    w: 'full',
    flexDir: 'column',
    mb: '2',
    pt: '2',
    _last: {
      borderBottom: 'none',
    },
  },
};
